import React, { useContext, useState } from 'react'

import {Swiper, SwiperSlide} from 'swiper/react'
// import swper styles
import "swiper/css";
import 'swiper/css/pagination';
import 'swiper/css/navigation'
import '../slider.css'
//requireds
import {Pagination, Navigation} from 'swiper'
import img1 from '../img/1.png'
import img2 from '../img/2.png'
import img3 from '../img/3.jpg'
import img4 from '../img/4.jpg'
import img5 from '../img/5.jpg'
import img6 from '../img/6.jpg'
import vsa from '../img/222.png'
import descrption from '../img/b8ad7ec7f256eb5f223572fcae0e9df1.jpeg'
import { IoStar, IoStarHalf } from 'react-icons/io5';
import {FaMinus, FaPlus} from 'react-icons/fa6'
import { CartContext } from '../context/CartContext';
function Product() {
  const { addToCart,setitem, setIsOpen} = useContext(CartContext);
  const [img, setimg] = useState(img1)
  const [num, setnum] = useState(1)
  function number(num){
    if(num === 1){
      window.alert('Please enter a nember more than one')
    }else{
      setnum(num-1)
    }
  }
  return (
    <>
        <div className='con my-5 relative flex justify-between flex-wrap md:flex-nowrap'>
    <div className='md:w-[50%] w-[100%]'>
      <div className=' sticky md:z-10  top-0'>
        <img src={img} className=' md:rounded-[0px] rounded-sm' alt=''/>
    
    {/* two */}
    <ul className=''>
      <li className=' text-decoration-none '>
      <Swiper className=' my-8'  modules={[Pagination, Navigation]} loop={false} navigation={true}
    breakpoints={{
      200:{
        slidesPerView:3,
        spaceBetween: 30
      },
      768:{
        slidesPerView: 3,
        spaceBetween: 30
      },
      1024:{
        slidesPerView: 3,
        spaceBetween: 30
      },
      1440: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    }}
    // pagination={{
    //   clickable:true,
    // }}
    >
        <SwiperSlide >
        <button onClick={()=> setimg(img1)} className={`${img===img1 ? 'border border-x-black border-y-black' : ''} duration-300 transition-all rounded-md hover:opacity-70 cursor-pointer bg-transparent overflow-hidden`}>
          <img src={img1}  className=' md:rounded-[0px] rounded-sm' alt=''/>
        </button>
        </SwiperSlide>
        <SwiperSlide >
        <button onClick={()=> setimg(img2)} className={`${img===img2 ? 'border border-x-black border-y-black' : ''} duration-300 transition-all rounded-md hover:opacity-70 cursor-pointer bg-transparent overflow-hidden`}>
          <img src={img2}  className=' md:rounded-[0px] rounded-sm' alt=''/>
        </button>
        </SwiperSlide>
        <SwiperSlide >
        <button onClick={()=> setimg(img3)} className={`${img===img3 ? 'border border-x-black border-y-black' : ''} duration-300 transition-all rounded-md hover:opacity-70 cursor-pointer bg-transparent overflow-hidden`}>
          <img src={img3}  className=' md:rounded-[0px] rounded-sm' alt=''/>
        </button>
        </SwiperSlide>
        <SwiperSlide >
        <button onClick={()=> setimg(img4)} className={`${img===img4 ? 'border border-x-black border-y-black' : ''} duration-300 transition-all rounded-md hover:opacity-70 cursor-pointer bg-transparent overflow-hidden`}>
          <img src={img4}  className=' md:rounded-[0px] rounded-sm' alt=''/>
        </button>
        </SwiperSlide>
        <SwiperSlide >
        <button onClick={()=> setimg(img5)} className={`${img===img5 ? 'border border-x-black border-y-black' : ''} duration-300 transition-all rounded-md hover:opacity-70 cursor-pointer bg-transparent overflow-hidden`}>
          <img src={img5}  className=' md:rounded-[0px] rounded-sm' alt=''/>
        </button>
        </SwiperSlide>
        <SwiperSlide >
        <button onClick={()=> setimg(img6)} className={`${img===img6 ? 'border border-x-black border-y-black' : ''} duration-300 transition-all rounded-md hover:opacity-70 cursor-pointer bg-transparent overflow-hidden`}>
          <img src={img6}  className=' md:rounded-[0px] rounded-sm' alt=''/>
        </button>
        </SwiperSlide>
    </Swiper>
      </li>
    </ul>
      </div>
        
    </div>
    <div className='mx-4 md:my-4'>
      <h2 className=' font-bold'>40% OFF🎁Hungry Duck Shooting Toy Set（🎄Christmas Sale🎅Free shipping）</h2>
      <div className=' flex'>
      <h4 className=' text-red-500 font-bold'>$25.99</h4>
      <s><h4 className=' text-gray-500 ml-8 font-bold'>$45.99</h4></s>
      <button className='btn btn-accent w-10 h-8 ml-10 text-white cursor-auto'>Sale</button>
      </div>
      <div className='flex justify-start my-4'>
        <IoStar className=' text-accent'/>
        <IoStar className=' text-accent' />
        <IoStar className=' text-accent' />
        <IoStar className=' text-accent' />
        <IoStarHalf className=' text-accent'/>
        <a href='#c'><p className=' font-medium text-[16px] ml-2 cursor-pointer'>90 reviews</p></a>
        
      </div>
        <p className=' font-bold text-[15px] text-gray-400 mb-4'>Style</p>
      <div className=' flex mb-5 max-w-[37rem]  cursor-pointer'>
        <h3 onClick={()=> setimg(img6)} className={`${img===img6 ? 'bg-red-500' : ''} duration-300 transition-all font-bold btn cursor-pointer px-2 mr-6 hover:border-body border-red-500 border rounded-md`}>Normal style</h3>
        <h3 onClick={()=> setimg(img1)} className={`${img===img1 ? 'bg-red-500' : ''} duration-300 transition-all font-bold btn cursor-pointer px-2 mr-6 hover:border-body border-red-500 border rounded-md`}>Upgraded style（Scoring with sound and light）</h3>
      </div>
      <div className=' flex mb-5 max-w-[37rem]  cursor-pointer justify-between'>
        <h3 onClick={()=> setimg(img5)} className={`${img===img5 ? 'bg-red-500' : ''} duration-300 transition-all font-bold btn cursor-pointer px-2 mr-6 hover:border-body border-red-500 border rounded-md`}>New Arrive🎁 Dinosaur（Scoring with sound and light）🎁</h3>
      </div>
      <div className=' my-4'>
        <p className=' text-[14px] font-medium text-gray-500 mb-4'>Quantity</p>
        <div className='flex w-[170px] border-2 border-gray-500 cursor-pointer rounded-md'>
          <FaMinus onClick={()=> number(num)}/>
          <input type='number' min={1} value={num} className=' w-10 h-6 text-center ml-12'/>
          <FaPlus onClick={()=> setnum(num+1)} className=' text-end ml-12'/>
        </div>
      </div>
      <div className='my-4' onClick={()=>setIsOpen(true)}  >
        <h4 onClick={()=>setitem(num)} className=' duration-300 transition-all cursor-pointer text-center p-4 btn hover:bg-accent border-2 border-black hover:border-accent'>Add to cart</h4>
      </div>
        <h4 onClick={()=>setIsOpen(true)} className=' text-center p-4 btn hover:bg-accent border-2 border-black duration-300 transition-all cursor-pointer hover:border-accent mt-6'>Buy</h4>
      <div className=' my-7'>
        <img className=' cursor-pointer' src={vsa}/>
      </div>
      <div className='my-8'>
        <img src={img2} className=' rounded-md'/>
      </div>
      <div className=' my-4'>
        <p className='text-[14px] line text-gray-500 leading-[32px]'>
        It's a popular multiplayer game, suitable for daily play and games. The duck target shooting toy designed an electric scoring target with a digital LCD records score. When a foam ball hits the target's tongue, it will make a dynamic sound and count 1 point in the score display (It only needs 2 AA batteries ).An exciting challenge for Kids to compete with parents or friends. Great competitive training for multiplayer or solo. Competition and increases parent-child relationships.
        </p>
        <p className='text-[14px] line text-gray-500 my-4 leading-[25px]'>
          <span className=' text-[17px] font-bold'>Safe & Durable: </span>
          Duck targets and guns are made of safe and durable ABS material. The smooth surface will not hurt kids' small hands.
        </p>
        <p className='text-[14px] line text-gray-500 my-4 leading-[25px]'>
          <span className=' text-[17px] font-bold'>Air Pump Shooting: </span>
          The principle of the gun: use air to squeeze out bullets. The range is up to 33 feet. The butt of the air pump gun is 360° rotate shooting. The design of 2 guns makes the shooting game a score competition and a fierce CS battle without duck target for more fun!
        </p>
        <p className='text-[14px] line text-gray-500 my-4 leading-[25px]'>
          <span className=' text-[17px] font-bold'>Great Gift Idea: </span>
          Target Practice Toys will help your kids enhance eye-hand coordination, concentration, parent-child relationship and keep them away from computers, mobile phones, and TV. Also perfect for adult release emotions. It is a great gift idea for parties, holidays, birthday boys and girls aged 5+.
        </p>
        <img src={descrption} alt='' className='my-4 rounded-md'/>
        <div className=' my-4 text-gray-500 text-[15px] leading-8'>
          <p>Duck size: 23*12*13cm,</p>
          <p>Toy gun size: 40*16cm</p>
        </div>
        <div className=' my-4 text-gray-500 text-[15px] leading-[32px]'>
          <p className=' font-bold'>Specifications:</p>
          <p>Material: ABS/EVA</p>
          <p>Size: As picture shows</p>
          <p>Battery: 2* AA batteries (Not included)</p>
        </div>
        <div className=' my-4 text-gray-500 text-[15px] leading-[40px]'>
          <p className=' font-bold'>Package Included:</p>
          <p>Please see the images for reference.</p>
          <div className='flex justify-start'>
        <IoStar/>
        <IoStar  />
        <IoStar />
        <IoStar  />
        <IoStarHalf />
        <p className=' font-medium text-[13px] ml-2 h-[15px] -mt-2'>(90)</p>

      </div>
        </div>
      </div>
    </div>

    </div>      
    </>



  )
}

export default Product